import dJSON from 'dirty-json';

const moduleSelector = '.career-opportunities';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.querySelector('.career-opportunities__grid').insertAdjacentHTML('beforeend', /* html */ `
          ${item.link ? `<a href="${item.link}" class="career-opportunities__card">` : '<div class="career-opportunities__card">'}
          <div class="career-opportunities__card-inner">
            ${item.icon ? `<div class="career-opportunities__icon">
              <img src="${item.icon}" alt="${item.title}">
            </div>` : ''}
            <div class="career-opportunities__content">
              <h4 class="career-opportunities__title">${item.title}</h4>
            </div>
          </div>
          ${item.link ? '</a>' : '</div>'}
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();

/**
 * intersection animation
 */
(() => {
  const observer = new IntersectionObserver((e) => {
    e.forEach((item) => {
      if (item.isIntersecting) {
        item.target.classList.add('career-opportunities__grid--active');
      } else {
        item.target.classList.remove('career-opportunities__grid--active');
      }
    });
  });

  document.querySelectorAll('.career-opportunities__grid')
    .forEach((item) => {
      observer.observe(item);
    });
})();
